import { hooks } from '@wove/react';
import { BasicDomTarget, getTargetElement } from '../utils';
import { useEffectCustom } from './use-effect-custom';

/**
 * 原生api中用来监听node节点变化
 * @param effect
 * @param targetRef
 * @param options
 */
export function useMutationEffect(
  effect: () => void,
  target: BasicDomTarget<Element | Document>,
  options: MutationObserverInit,
) {
  const fn = hooks.useCallbackRef(effect);
  useEffectCustom(() => {
    const observer = new MutationObserver(() => {
      fn();
    });
    const element = getTargetElement(target);
    if (element) {
      observer.observe(element, options);
    }
    return () => {
      observer.disconnect();
    };
  }, [fn, target]);
}
